<template>
    <footer class="bg-dark text-light py-4 mt-auto">
        <div class="container">
            <div class="row">
                <div class="col-md-4 mb-3 mb-md-0">
                    <h5>Acerca de Clave Verde</h5>
                    <p class="text-muted">
                        Programa del gobierno estatal que proporciona chips gratuitos con 
                        internet mensual para estudiantes de preparatoria y universidad, 
                        facilitando su conectividad educativa.
                    </p>
                </div>
                <div class="col-md-4 mb-3 mb-md-0">
                    <h5>Enlaces</h5>
                    <ul class="list-unstyled">
                        <li>
                            <router-link :to="{name: 'Home'}" class="text-muted text-decoration-none">
                                Inicio
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'Compatibility'}" class="text-muted text-decoration-none">
                                Compatibilidad
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'Portability'}" class="text-muted text-decoration-none">
                                Portabilidad
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'About'}" class="text-muted text-decoration-none">
                                Acerca de
                            </router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'TermsAndConditions'}" class="text-muted text-decoration-none">
                                Términos y condiciones
                            </router-link>
                        </li>
                        <!-- <li><a href="#" class="text-muted text-decoration-none">Contacto</a></li> -->
                    </ul>
                </div>
                <div class="col-md-4">
                    <h5>Contacto</h5>
                    <p class="text-muted mb-1">Email: <a href="mailto: soporte@claveverde.mx">soporte@claveverde.mx</a></p>
                    <p class="text-muted">Tel: <a href="tel:4442400240">(44) 4240 0240</a> o al <a href="tel: *678">*678</a> </p>
                </div>
            </div>
            <hr class="bg-secondary">
            <div class="row">
                <div class="col text-center">
                    <p class="text-muted mb-0">&copy; {{ year }} Clave Verde. Todos los derechos reservados.</p>
                </div>
            </div>
        </div>
    </footer>
</template>

<script>
export default {
    name: 'NavFooter',
    props: {
        year: {
            type: Number,
            default: new Date().getFullYear()
        }
    }
};
</script>